// extracted by mini-css-extract-plugin
export var grid = "fp-MT";
export var gridWithRowGap = "fp-NT";
export var maxWidthContainer = "fp-RT";
export var mt0 = "fp-ET";
export var mt1 = "fp-FT";
export var mt2 = "fp-GT";
export var mt3 = "fp-HT";
export var mt4 = "fp-IT";
export var mt5 = "fp-JT";
export var mt6 = "fp-KT";
export var removeVisuallyHidden = "fp-PT";
export var signInSelector__icon = "fp-UT";
export var signInSelector__link = "fp-TT";
export var signInSelector__linkButton = "fp-ST";
export var signInSelector__linkFocus = "fp-LT";
export var visuallyHidden = "fp-OT";
export var widgetBase = "fp-QT";